/* eslint-disable */
<template>
  <section class="assess-page">

    <!-- Not logged in -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to access your payment receipt.</p>
        <router-link class="login-btn" to="/login">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- Logged in -->
    <div v-else class="page-body">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Assessment Tax</p>
            <h1 class="page-title">Payment Receipt</h1>
            <p class="page-subtitle">{{ new Date().toLocaleString() }}</p>
          </div>
        </div>
      </div>

      <form @submit.prevent="submitForm" id="taxInvoince" novalidate autocomplete="off">

        <!-- Sabha Header Card -->
        <div class="form-card sabha-card" v-if="theSabhaData && theSabhaData[0]">
          <div class="sabha-inner ">
            <div class="sabha-gov-badge">LG</div>
            <div class="sabha-info">
              <span class="system-title">Local Government Online Payment Management System</span>
              <span class="sabha-address">{{ theSabhaData[0].sb_address }}</span>
              <span class="sabha-contact">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.948V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                Tel: {{ theSabhaData[0].sb_contact }} &nbsp;|&nbsp; Fax: {{ theSabhaData[0].fax }}
              </span>
            </div>
            <div class="invoice-pill">
              <span class="inv-label">Invoice No.</span>
              <span class="inv-number">{{ invoice_num }}</span>
            </div>
          </div>
        </div>

        <!-- Property Details -->
        <div class="form-card">
          <!-- <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Property Details</h2>
              <p class="card-desc">Registered property information</p>
            </div>
          </div> -->

          <div class="info-grid">
            <div class="info-field">
              <span class="info-label">Assessment Owner(s)</span>
              <span class="info-value">{{ customeName }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Property Address</span>
              <span class="info-value">{{ cusAddress }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Ward Number</span>
              <span class="info-value">{{ ward }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Road / Street</span>
              <span class="info-value">{{ street }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Assessment / Used No.</span>
              <span class="info-value">{{ assess_number }} / {{ used_number }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">K Form Reference</span>
              <span class="info-value">{{ property_id }}</span>
            </div>
          </div>
          <div>
              <p class="card-desc">Summary of amounts due</p>
            </div>
  <div class="amount-list">
            <div class="amount-row">
              <span class="amount-key">Arrears / Excess Amount</span>
              <span class="amount-val">Rs. {{ parseFloat(excess_arrears).toFixed(2) }}</span>
            </div>
            <div class="amount-row">
              <span class="amount-key">Quarter Amount</span>
              <span class="amount-val">Rs. {{ parseFloat(quater_amount).toFixed(2) }}</span>
            </div>
            <div class="amount-row">
              <span class="amount-key">Assessment Fine</span>
              <span class="amount-val fine-val">Rs. {{ parseFloat(fine).toFixed(2) }}</span>
            </div>
            <div class="amount-row">
              <span class="amount-key">Assessment Discount</span>
              <span class="amount-val discount-val">Rs. {{ parseFloat(discount).toFixed(2) }}</span>
            </div>
            <div class="amount-row">
              <span class="amount-key">Assessment Balance Forwarded</span>
              <span class="amount-val balance-val">Rs. {{ parseFloat(Math.abs(balanceAmount)).toFixed(2) }}</span>
            </div>
            <div class="amount-divider"></div>
            <div class="amount-row">
              <span class="amount-key">Payable Amount</span>
              <span class="amount-val">Rs. {{ parseFloat(paid_amount).toFixed(2) }}</span>
            </div>
            <div class="amount-row">
              <span class="amount-key">Banking Service Charge</span>
              <span class="amount-val">Rs. {{ bankfee }}</span>
            </div>
          </div>

          <div class="grand-total-box">
            <span class="gt-label">Grand Total</span>
            <span class="gt-value">Rs. {{ grandPayTotal }}</span>
          </div>
        </div>
          <!-- Description -->
          <!-- <div class="desc-box">
            <div class="desc-header">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              Description
            </div>
            <div class="desc-body">{{ remark }}</div>
          </div> -->
      
            

        <!-- Certify & Pay Card -->
        <div class="form-card certify-card">
          <label class="certify-label">
            <input @click="btnenable" type="checkbox" id="checkid" v-model="checkVal" class="certify-check" />
            <span class="certify-text">
              I certify that the above information is true and correct.
              <span class="sinhala">| ඉහත තොරතුරු සත්‍ය හා නිවැරදි බවට සහතික කරමි.</span>
            </span>
          </label>

          <div
            class="form-actions"
            v-if="theSabhaData && theSabhaData[0] && theSabhaData[0].saba_ipg == 'BOC'"
          >
            <button class="pay-btn" id="payboc" type="submit" :disabled="disableButton">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
              </svg>
              Pay Now 
              <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
              </svg>
            </button>
          </div>
        </div>

      </form>

      <div v-html="form" id="formResponse" style="display: none;"></div>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
  name: "AssessmentTaxInvoice",
  data() {
    return {
      grandPayTotal: 0, bankfee: 0,
      cusName: '', Sname: '', customeName: '',
      monthName: '', checkVal: '', sessionData: '',
      InvouceNum: '', sabha_code: '', remark: '',
      pay_head: 0, nextid: '', Nic: '', payamount: {},
      invoice_num: '', property_id: '', assess_number: '',
      used_number: '', cusContact: '', cusAddress: '',
      excess_arrears: '', quater_amount: '', discount: '',balanceAmount:'',
      paid_amount: '', paymonth: '', sub_nic: '',
      theSabhaData: [], matchUser: undefined,
      postData: {
        mid: '', paytype: '', amount: '', referenceNumber: '', email: '',
        bill_to_forename: '', bill_to_surname: '', bill_to_address_line1: '',
        bill_to_address_city: '', bill_to_address_state: '',
        bill_to_address_postal_code: '', bill_to_address_country: 'LK',
      },
      response: null, error: null, currentDate: new Date(),
      fine: 0, Checkout: null,
      pay_vote: 'assessmenttax', ward: '', street: '',
      formData: {
        boc_sid: '', boc_paytype: '', boc_amount: '', boc_grandamount: '',
        boc_cus_nic: '', boc_invoice: '', boc_remarks: '',
        country: '', street: '', street2: '', city: '', state: '', zip: '',
      },
      ipg: '', disableButton: true,
    };
  },
  created() {
    this.getSessionData();
    this.ShowMonthName();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapMutations(["setUser"]),

    formattedDate() {
      let date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    async MatchUser(nic) {
      let data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },

    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('taxDetails'));
      if (data) {
        this.invoice_num = data.invoice_num;
        this.sabha_code = data.sabha_code;
        this.property_id = data.property_id;
        this.ward = data.ward;
        this.street = data.street;
        this.assess_number = data.assess_number;
        this.used_number = data.used_number;
        this.customeName = data.cus_name;
        this.cusContact = data.cus_contact;
        this.cusAddress = data.cus_address;
        this.remark = data.remark;
        this.excess_arrears = data.excess_arrears;
        this.quater_amount = data.quater_amount;
        this.fine = data.fine;
        this.discount = data.discount;
        this.balanceAmount=data.balanceAmount
        this.paid_amount = data.paid_amount;
        this.paymonth = data.paymonth;
        this.sub_nic = data.sub_nic;
      }
      this.sessionData = data;
      const nicdata = JSON.parse(sessionStorage.getItem('Userdata'));
      if (nicdata) { this.Nic = nicdata.Unic; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
      if (this.sessionData) {
        this.theSabhaData = (await axios.get('/PraSabhadata/' + this.sabha_code)).data;
        this.Sname = 'tax';
        this.ipg = this.theSabhaData[0].saba_ipg;
        let datau = await axios.get('/customersdata/' + this.user.cus_nic);
        this.matchUser = datau.data;
        this.cusName = this.matchUser.cus_name;
          if (this.user) {
              if (this.ipg == 'BOC') {
                this.bankfee = (parseFloat(this.paid_amount) * ((100 / (100 - 1)) - 1)).toFixed(2);
              }
              if (this.ipg == 'people') {
                this.bankfee = (parseFloat(this.paid_amount) * 0.01).toFixed(2);
              }
              this.grandPayTotal = (parseFloat(this.bankfee) + parseFloat(this.paid_amount)).toFixed(2);
            }
        this.postData.mid = this.sabha_code;
        this.postData.paytype = 'tax';
        this.postData.amount = this.grandPayTotal;
        this.postData.referenceNumber = this.invoice_num;
        this.postData.email = this.user.cus_email;
        this.postData.bill_to_forename = this.property_id;
        this.postData.bill_to_surname = this.customeName;
        this.postData.bill_to_address_line1 = this.user.cus_nic;
        this.postData.bill_to_address_city = this.Sname;
        this.postData.bill_to_address_country = 'LK';
        axios.post('/process-payment', this.postData, { headers: { 'Content-Type': 'application/json' } })
          .then((response) => {
            this.response = response.data;
            document.getElementById('formResponse').innerHTML = response.data;
          })
          .catch((error) => { this.error = error; });
      } else {
        this.$router.push('/assessmenttaxnew');
      }
    },

    submitForm() {
      this.formData.boc_sid = this.sabha_code;
      this.formData.boc_paytype = 'tax';
      this.formData.boc_amount = this.paid_amount;
      this.formData.boc_grandamount = this.grandPayTotal;
      this.formData.boc_cus_nic = this.property_id;
      this.formData.boc_invoice = this.invoice_num;
      this.formData.boc_remarks = this.remark;
      this.formData.country = 'LKA';
      this.formData.street = '25466';
      this.formData.street2 = this.user.cus_nic;
      this.formData.city = '25466';
      this.formData.state = '25466';
      this.formData.zip = '25466';
      const storedBackendUrl = window.sessionStorage.getItem("backendUrl") || "https://elgservices.com.lk/acc";
      axios.post(storedBackendUrl + '/bocpay/', this.formData)
        .then(response => {
          // window.location.href = "https://bankofceylon.gateway.mastercard.com/checkout/pay/" + response.data.sessionid + "?checkoutVersion=1.0.0";
         window.location.href = "https://test-bankofceylon.mtf.gateway.mastercard.com/checkout/pay/"+response.data.sessionid+"?checkoutVersion=1.0.0"   // test url
        })
        .catch(error => { console.error(error); });
    },

    getMonthName(monthNumber) {
      const date = new Date();
      date.setMonth(monthNumber);
      return date.toLocaleString('en-US', { month: 'long' });
    },

    ShowMonthName() {
      this.monthName = this.getMonthName(this.month);
    },

    btnenable() {
      if (this.checkVal == true) {
        document.getElementById('formResponse').style.display = 'none';
        this.disableButton = true;
      } else {
        document.getElementById('formResponse').style.display = 'block';
        this.disableButton = !this.disableButton;
      }
    },
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Page ── */
.assess-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 900px; margin: 0 auto; width: 100%; }

/* ── Login Prompt ── */
.login-prompt { display: flex; align-items: center; justify-content: center; min-height: 80vh; }
.login-card {
  background: #fff; border-radius: 1.4rem; padding: 4rem 3.5rem;
  text-align: center; max-width: 420px; width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,0.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.8rem; }
.login-card p  { font-size: 1.45rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1.1rem 2.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.5rem; font-weight: 600;
  text-decoration: none; transition: all 0.2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.35); }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.8rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Cards ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.4rem;
  margin-bottom: 1.6rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  transition: box-shadow 0.2s;
}
.form-card:hover { box-shadow: 0 4px 18px rgba(100,50,30,0.10); }

/* ── Sabha Header Card ── */
.sabha-card { padding: 0; overflow: hidden; }
.sabha-inner {
  display: flex; align-items: center; gap: 2rem;
  background: linear-gradient(135deg, #e5ddd5 0%, #e5ddd5 100%);
  padding: 2rem 2.4rem; flex-wrap: wrap;
}
.sabha-gov-badge {
  width: 5.5rem; height: 5.5rem; border-radius: 50%;
  background: rgba(255,255,255,0.15); border: 2px solid rgba(255,255,255,0.3);
  color: #4e0505; font-family: 'DM Serif Display', serif;
  font-size: 1.8rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.sabha-info { display: flex; flex-direction: column; gap: 0.35rem; flex: 1; }
.system-title { font-size: 1.1rem; color: #4e0505; font-weight: 400; }
.sabha-address { font-size: 1.45rem; color: #4e0505; font-weight: 600; }
.sabha-contact { display: flex; align-items: center; gap: 0.5rem; font-size: 1.3rem; color: #4e0505; }
.sabha-contact svg { width: 1.4rem; height: 1.4rem; flex-shrink: 0; }
.invoice-pill { display: flex; flex-direction: column; align-items: flex-end; gap: 0.3rem; flex-shrink: 0; }
.inv-label { font-size: 1.1rem; color: #4e0505; letter-spacing: 0.08em; text-transform: uppercase; }
.inv-number {
  font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #4e0505; font-weight: 700;
  background: rgba(255,255,255,0.15); padding: 0.3rem 1.2rem; border-radius: 0.5rem;
  border: 1px solid rgba(255,255,255,0.25);
}

/* ── Card Header ── */
.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 2rem; padding-bottom: 1.5rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 4rem; height: 4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.9rem; height: 1.9rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.card-desc { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Info Grid (2 columns inside single-column card) ── */
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.4rem 2rem;
  margin-bottom: 1.6rem;
}
.info-field { display: flex; flex-direction: column; gap: 0.3rem; }
.info-label { font-size: 1.1rem; font-weight: 500; color: #9a8070; text-transform: uppercase; letter-spacing: 0.06em; }
.info-value { font-size: 1.45rem; font-weight: 600; color: #1c0f0a; }

/* ── Description Box ── */
.desc-box { background: #faf8f6; border: 1px solid #e5ddd5; border-radius: 0.8rem; overflow: hidden; }
.desc-header {
  display: flex; align-items: center; gap: 0.6rem;
  padding: 0.9rem 1.4rem; background: #f0ebe3;
  font-size: 1.3rem; font-weight: 600; color: #4a3028;
  border-bottom: 1px solid #e5ddd5;
}
.desc-header svg { width: 1.5rem; height: 1.5rem; stroke: #7c2d12; flex-shrink: 0; }
.desc-body { padding: 1.2rem 1.4rem; font-size: 1.35rem; color: #4a3028; line-height: 1.7; white-space: pre-wrap; }

/* ── Amount List ── */
.amount-list { display: flex; flex-direction: column; margin-bottom: 1.6rem; }
.amount-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1rem 0; border-bottom: 1px solid #f0ebe3;
}
.amount-row:last-child { border-bottom: none; }
.amount-key { font-size: 1.35rem; color: #4a3028; }
.amount-val { font-size: 1.35rem; font-weight: 600; color: #1c0f0a; font-variant-numeric: tabular-nums; }
.fine-val { color: #b91c1c; }
.discount-val { color: #15803d; }
.balance-val{ color: #080a84; }
.amount-divider { height: 1px; background: #e5ddd5; margin: 0.4rem 0; }

/* ── Grand Total ── */
.grand-total-box {
  display: flex; align-items: center; justify-content: space-between;
  background: linear-gradient(135deg, #e5ddd5, #e5ddd5);
  border-radius: 0.8rem; padding: 1.4rem 1.8rem;
}
.gt-label { font-size: 1.4rem; color: #4e0505; font-weight: 500; }
.gt-value { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #4e0505; }

/* ── Certify Card ── */
.certify-card { display: flex; align-items: center; justify-content: space-between; gap: 2rem; flex-wrap: wrap; }
.certify-label { display: flex; align-items: flex-start; gap: 1rem; cursor: pointer; flex: 1; }
.certify-check { margin-top: 0.3rem; width: 1.8rem; height: 1.8rem; accent-color: #7c2d12; flex-shrink: 0; cursor: pointer; }
.certify-text { font-size: 1.35rem; color: #1c0f0a; line-height: 1.6; }
.sinhala { color: #9a8070; font-size: 1.25rem; }

/* ── Pay Button ── */
.form-actions { display: flex; justify-content: flex-end; flex-shrink: 0; }

.pay-btn {
  display: inline-flex; align-items: center; gap: 0.8rem;
  padding: 1.2rem 2.8rem;
  background: linear-gradient(135deg, #166534, #16a34a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(22,101,52,0.35), 0 0 0 3px rgba(22,163,74,0.15);
  transition: all 0.2s;
}
.pay-btn svg { width: 1.8rem; height: 1.8rem; }
.arrow-icon { transition: transform 0.2s; }

.pay-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #14532d, #15803d);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(22,101,52,0.45), 0 0 0 4px rgba(22,163,74,0.2);
}
.pay-btn:hover:not(:disabled) .arrow-icon { transform: translateX(4px); }

.pay-btn:disabled {
  opacity: 0.38;
  cursor: not-allowed;
  box-shadow: none;
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .assess-page { padding: 1.5rem 1rem 3rem; }
  .page-title { font-size: 2rem; }
  .sabha-inner { flex-direction: column; align-items: flex-start; }
  .invoice-pill { align-items: flex-start; }
  .info-grid { grid-template-columns: 1fr; }
  .certify-card { flex-direction: column; align-items: flex-start; }
  .form-actions { width: 100%; }
  .pay-btn { width: 100%; justify-content: center; }
}
</style>